module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"To go to level 5 or vip, you can contact the support to sign the contract.":"برای رفتن به سطح 5 یا vip میتوانید با پشتیبانی جهت امضای قرارداد در تماس باشید.","You have successfully completed all the steps of authentication.":"با موفقیت تمامی مراحل احراز هویت را انجام داده اید."}}')
  delete Component.options._Ctor
}
